import React, { FC, FormEvent } from 'react';
import { Button, Stack, TextField, Typography } from '@mui/material';

import MenuItem from '@mui/material/MenuItem';
import { AlertBar } from '../../../../components/AlertBar';

interface SetPackagesModalProps {
  onFinished: () => void;
  organizationName?: string;
}

export const SetPackagesModal: FC<SetPackagesModalProps> = ({
  onFinished,
  organizationName,
}) => {
  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    onFinished();
  };
  const packageData = [
    { id: 1, package: 'Free - 1 screen' },
    { id: 2, package: ' Silver - 5 screens - Monthly subscription : TBD' },
    { id: 3, package: 'Gold - 15 screens - Monthly subscription : TBD' },
    { id: 4, package: 'Plat - 50 screens - Monthly subscription : TBD' },
    { id: 5, package: 'Enterprise - Unlimited screens - contact sales' },
  ];
  return (
    <Stack spacing={2} sx={{ pt: 2 }}>
      <AlertBar severity="error" />
      <Typography sx={{ color: '#64748b' }}>
        Choose the screen allowance for{' '}
        <Typography component="span" sx={{ color: '#0f172a', fontWeight: 700 }}>
          {organizationName || 'this organization'}
        </Typography>
        . The package determines how many displays the organization can manage.
      </Typography>
      <form onSubmit={handleSubmit}>
        <Stack spacing={2}>
          <TextField size="small" fullWidth label="Package" id="package" select>
            {packageData.map((option) => (
              <MenuItem key={option.package} value={option.package}>
                {option.package}
              </MenuItem>
            ))}
          </TextField>

          <Button
            color="primary"
            variant="contained"
            fullWidth
            type="submit"
            sx={{ height: 40 }}
          >
            Save package
          </Button>
        </Stack>
      </form>
    </Stack>
  );
};
